module.exports = __webpack_public_path__ + "static/media/icon.722a3865.png";